import { format } from 'date-fns';

const CustomizedTick = (props) => {
  const { x, y, payload } = props;
  const date = new Date(payload.value);

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fill="#666">
        <tspan textAnchor="middle" x="0">
          {format(date, 'dd.MM')}
        </tspan>
        <tspan textAnchor="middle" x="0" dy="20">
          {format(date, 'HH:mm')}
        </tspan>
      </text>
    </g>
  );
};

export default CustomizedTick;
